//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { nanoid } from 'nanoid';
import CustomDatepicker from '~/components/UI/Inputs/CustomDatepicker.vue';
import ChildDataRow from '~/components/DataTables/ChildDataRow.vue';

export default {
    name: 'DaysOffCalculator',
    components: { ChildDataRow, CustomDatepicker },
    data() {
        return {
            form: {
                birth_date: null,
                has_children: false,
                has_disability: false,
                has_fixed_term_employment: false,
                children: [],
                work_start_date: null,
                work_end_date: null,
                started_working_this_year: false,
                has_ionized_environment: false,
                has_caregiver_status: false,
                has_extreme_work_environment: false,
            },
            isWorkStartDateCalendarOpen: false,
            isWorkEndDateCalendarOpen: false,
            isBirthDateCalendarOpen: false,
            isCountingInProgress: false,
            isCalculated: false,
            total: 20,
            details: null,
        };
    },
    head() {
        return {
            title: `Holi - ${this.$t('days_off_calculator.title')}`,
        };
    },
    watch: {
        'form.has_children'(newValue) {
            if (!newValue) {
                this.form.children = [];
            } else if (this.form.children.length === 0) {
                this.form.children.push({
                    id: nanoid(),
                    birth_year: null,
                    has_disability: false,
                });
            }
        },
        'form.has_fixed_term_employment'(newValue) {
            if (!newValue) {
                this.form.work_end_date = null;
            }
        },
        'form.started_working_this_year'(newValue) {
            if (!newValue) {
                this.form.work_start_date = null;
            }
        },
        'form.work_start_date'(newValue) {
            if (this.$dayjs(String(newValue), 'YYYY-MM-DD', true).$y) {
                this.onSubmit();
            }
        },
        'form.work_end_date'(newValue) {
            if (this.$dayjs(String(newValue), 'YYYY-MM-DD', true).$y) {
                this.onSubmit();
            }
        },
        form: {
            handler(newVal, oldVal) {
                const isValidDate = (date) => this.$dayjs(date, 'YYYY-MM-DD', true).isValid();
                const isNull = (date) => date === null;

                const birthDateValid = isValidDate(this.form.birth_date);
                const workStartDateValid = isValidDate(this.form.work_start_date) || isNull(this.form.work_start_date);
                const workEndDateValid = isValidDate(this.form.work_end_date) || isNull(this.form.work_end_date);

                if (birthDateValid && workStartDateValid && workEndDateValid) {
                    this.onSubmit();
                }
            },
            deep: true,
        },
    },
    methods: {
        async onSubmit() {
            this.isCountingInProgress = true;

            if (this.form.birth_date) {
                this.form.birth_date = this.$dayjs(this.form.birth_date).format('YYYY-MM-DD');
            }
            if (this.form.work_start_date) {
                this.form.work_start_date = this.$dayjs(this.form.work_start_date).format('YYYY-MM-DD');
            }
            if (this.form.work_end_date) {
                this.form.work_end_date = this.$dayjs(this.form.work_end_date).format('YYYY-MM-DD');
            }
            try {
                await this.$axios.$post('/site/calculate-days-off', this.form).then((res) => {
                    if (res.success === 1) {
                        this.isCalculated = true;
                        this.details = res.data;
                        this.isCountingInProgress = false;
                    } else {
                        this.$nextTick(() => {
                            if (this.$refs.formWrapper) {
                                this.$refs.formWrapper.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'center',
                                });
                            }
                        });
                        this.isCalculated = false;
                        this.$refs.form.setErrors(res.error);
                    }
                    this.isCountingInProgress = false;
                });
            } catch (error) {
                console.log(error);
            }
        },
        setBirthDate(val) {
            this.form.birth_date = val;
        },
        scrollToResults() {
            if (!this.form.birth_date) return;
            this.$nextTick(() => {
                if (this.$refs.result) {
                    this.$refs.result.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });
                }
            });
        },
        setWorksStartDate(val) {
            this.form.work_start_date = val;
        },
        setWorksEndDate(val) {
            this.form.work_end_date = val;
        },
        addChild() {
            this.form.children.push({
                id: nanoid(),
                birth_year: null,
                has_disability: false,
            });
        },
        setChildBirthYear(id, value) {
            const childrenCopy = [...this.form.children];
            childrenCopy.find((x) => x.id === id).birth_year = value;
            this.form.children = childrenCopy;
        },
        setChildHasDisability(id, value) {
            const childrenCopy = this.$clone(this.form.children);
            childrenCopy.find((x) => x.id === id).has_disability = value;
            this.form.children = childrenCopy;
        },
        removeChild(id) {
            this.form.children = this.form.children.filter((c) => c.id !== id);
        },
    },
};
